import _ from 'lodash';
import { CreateEditPhysicalEnum, ItemEnum, FilterEnum } from 'Common/FieldEnum';

export const basicURL = '/physical';
export const getSaveObject = (
  values,
  OpType,
  physicalId,
  type,
  physicalData
) => {
  const saveObj = {
    Id: physicalId,
    SiteId: values[CreateEditPhysicalEnum.Site],
    Comments: values[CreateEditPhysicalEnum.Comments],
    PhysicalDate: values[CreateEditPhysicalEnum.PhysicalDT],
    SaveOption: OpType,
    PhysicalItems: [],
    Type: type,
    DeletedItems: [],
  };
  let index;
  _.each(physicalData, item => {
    index = _.findIndex(values[CreateEditPhysicalEnum.PhysicalItemsInfo], {
      [ItemEnum.ItemCode]: item[ItemEnum.ItemCode],
    });
    if (index === -1) {
      saveObj.DeletedItems.push(item[ItemEnum.ItemId]);
    }
  });

  saveObj.PhysicalItems = values[CreateEditPhysicalEnum.PhysicalItemsInfo].map(
    item =>
      (item[ItemEnum.PriQty] !== null || item[ItemEnum.SecQty] !== null ) && {
        SiteId: values[CreateEditPhysicalEnum.Site],
        ItemId: item[ItemEnum.ItemId],
        ItemCode: item[ItemEnum.ItemCode],
        Description: item[ItemEnum.Description],
        PkgDescription: item[ItemEnum.ItemPackaging],
        Unit: item[ItemEnum.Unit],
        SecondaryUnit: item[ItemEnum.SecondaryUnit],
        QtyPerUnit: item[ItemEnum.QtyPerUnit],
        PrimaryPrice: item[ItemEnum.PrimaryPrice],
        PriQty: item[ItemEnum.PriQty],
        SecQty: item[ItemEnum.SecQty],
        GroupId_Item: values[FilterEnum.GroupId_Item],
        GroupId_Bid: values[FilterEnum.GroupId_Bid],
        GroupId_Location: values[FilterEnum.GroupId_Location],
        EndQtyAsDecimal: values[CreateEditPhysicalEnum.EndQtyAsDecimal],
        NetValueChange: values[CreateEditPhysicalEnum.NetValueChange],
        Value: values[CreateEditPhysicalEnum.Value],
      }
  );
  return saveObj;
};

export const filterDataSource = (
  physicalItemsInfo,
  physicalItemsData,
  change,
  fieldName
) => {
  if (
    physicalItemsInfo &&
    physicalItemsInfo.length &&
    physicalItemsData &&
    physicalItemsData.length
  ) {
    const dataSourceCopy = _.cloneDeep(physicalItemsData);
    const valueCopy = _.cloneDeep(physicalItemsInfo);
    const removeValues = [];
    let index;
    _.each(valueCopy, item => {
      index = _.findIndex(dataSourceCopy, {
        [ItemEnum.ItemCode]: item[ItemEnum.ItemCode],
      });
      if (index === -1) {
        removeValues.push({ ...item });
      }
    });
    removeValues.length && _.pullAllBy(valueCopy, removeValues, 'ItemCode');
    change(fieldName, valueCopy);
  }
};

export const getValidData = (data) => {
  if (!data || data.length === 0) {
    return [];
  }
  return data.filter(item => {
    return (
      (item.PriQty !== null && _.trim(item.PriQty) !== '') ||
      (item.SecQty !== null && _.trim(item.SecQty) !== '')
    );
  });
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/helper/index.js